import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import { ProductGroup } from './product-group';
import deps from './deps';

export class ProductGroupView extends Backbone.View {
  initialize({
    campaign,
    adgroup,
    treeGridParameters,
    flattenGridParameters,
    isTreeView,
    preferenceConfig,
  }) {
    this.viewRef = React.createRef();
    this.view = (
      <ProductGroup
        ref={this.viewRef}
        deps={deps}
        campaign={campaign}
        adgroup={adgroup}
        treeGridParameters={treeGridParameters}
        flattenGridParameters={flattenGridParameters}
        isTreeView={isTreeView}
        preferenceConfig={preferenceConfig}
      />
    );
  }

  setState(state) {
    if (this.viewRef.current) {
      this.viewRef.current.setState(state);
    }
    return this;
  }

  render() {
    ReactDOM.render(this.view, this.el);
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
